import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-slide--right",
  "use": "icon-slide--right-usage",
  "viewBox": "0 0 9 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 9 12\" id=\"icon-slide--right\"><path d=\"M8.625 5.783a.25.25 0 0 1 0 .434L.375 10.98A.25.25 0 0 1 0 10.763V1.237a.25.25 0 0 1 .375-.217l8.25 4.763Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol